import React from "react";

const Tick = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" role="img" aria-label="Tick icon">
        <path stroke="#1A73E8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M2 9.154 5.75 13 14 3"/>
    </svg>
  );
};

export default Tick;
